import { useCurrentTime } from '../UserProfileCard/useCurrentTime'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'
import timezonePlugin from 'dayjs/plugin/timezone'

dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.extend(timezonePlugin)

interface Props {
  timezone?: string
  format?: string
}

export const LocalisedCurrentTime = ({ timezone = 'America/New_York', format = 'h:mm a' }: Props) => {
  const time = useCurrentTime(timezone)

  return <>{dayjs(time).tz(timezone).format(format)}</>
}
